module.exports = __webpack_public_path__ + "media/vid_top_case1.375ce481.mp4";